import React, { Component } from "react";
import Button from "../../UI/button/Button";
import FormButton from "../../UI/button/FormButton";
import axios from "../../../configAxios";
import { toast } from "react-toastify";
import Input from "../../UI/input/Input";
import ModalSpinner from "../../UI/ModalSpinner";

class NewProjectCues extends Component {
  signal = axios.CancelToken.source();
  state = {
    categoryNames: [],
    name: {
      elementType: "input",
      elementConfig: {
        name: "name",
        type: "text",
        required: true
      },
      label: "Attribute Name",
      value: ""
    },
    visible: {
      elementType: "input",
      elementConfig: {
        name: "visible",
        type: "checkbox",
        checked: false
      },
      label: "Visible"
    },
    isChecked: true,
    loading: false,
    disabled: false
  };

  componentDidMount() {
    if (this.props.edit) {
      this.setState({ ...this.state, loading: true })
      axios
        .get("/project_attribute_types/" + this.props.id, {
          cancelToken: this.signal.token
        })
        .then(res => {
          const { project_attribute_type } = res.data;
          this.setState({
            loading: false,
            name: {
              ...this.state.name,
              value: project_attribute_type.name
            },
            visible: {
              ...this.state.visible,
              elementConfig: {
                ...this.state.visible.elementConfig,
                checked: project_attribute_type.visible
              }
            }
          });
        });
    }
  }

  componentWillUnmount() {
    this.signal.cancel("Request is being Cancelled");
  }

  closeModal = () => {
    this.props.closeModal();
  };

  inputChangedHandler = (event, key) => {
    let inputValue = {};
    if (key === "name") {
      inputValue["value"] = event.target.value;
    }
    const updatedcontrols = {
      ...this.state[key],
      ...inputValue
    };
    this.setState({ [key]: updatedcontrols });
  };

  toggleCheckbox = event => {
    this.setState({
      visible: {
        ...this.state.visible,
        elementConfig: {
          ...this.state.visible.elementConfig,
          checked: !this.state.visible.elementConfig.checked
        }
      }
    });
  };

  submitHandler = event => {
    event.preventDefault();
    this.setState({ disabled: true })
    let attrData = {};
    const { name, visible } = this.state;
    attrData["name"] = name.value;
    attrData["category"] = "Cues";
    attrData["visible"] = visible.elementConfig.checked;
    if (this.props.edit) {
      axios
        .put(`/project_attribute_types/${this.props.id}`, attrData)
        .then(res => {
          if (res.data.json.success) {
            toast.success("Project submission successfully updated");
            this.props.closeModal();
            this.props.getProjectCuesList();
          } else {
            if (res.data.json.hasOwnProperty("errors")) {
              Object.keys(res.data.json.errors).forEach(error => {
                toast.error(error + " " + res.data.json.errors[error]);
              });
            }
            if (res.data.json.hasOwnProperty("error")) {
              toast.error(res.data.json.error);
            }
          }
          this.setState({ disabled: false })
        });
    } else {
      axios.post("/project_attribute_types", attrData).then(res => {
        if (res.data.json.success) {
          toast.success("Project submission successfully created");
          this.props.closeModal();
          this.props.getProjectCuesList();
        } else {
          if (res.data.json.hasOwnProperty("errors")) {
            Object.keys(res.data.json.errors).forEach(error => {
              toast.error(error + " " + res.data.json.errors[error]);
            });
          }
          if (res.data.json.hasOwnProperty("error")) {
            toast.error(res.data.json.error);
          }
        }
        this.setState({ disabled: false })
      });
    }
  };

  render() {
    return (
      <form className="mt-3" onSubmit={this.submitHandler}>
        {
          this.state.loading ? <ModalSpinner /> : (
            <React.Fragment>
              <Input
                {...this.state.name}
                changed={event => this.inputChangedHandler(event, "name")}
              />
              <Input
                {...this.state.visible}
                changed={event => this.toggleCheckbox(event, "visible")}
              />
              <div className="text-center">
                <Button type="secondary" clicked={this.props.closeModal}>
                  Cancel
                </Button>
                <FormButton className="ml-2" disabled={this.state.disabled}>
                  {this.props.edit ? "Update Project Submission" : "Create Project Submission"}
                </FormButton>
              </div>
            </React.Fragment>
          )
        }
      </form>
    );
  }
}

export default NewProjectCues;
